import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-top-left-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeWidth: 1.5, stroke: "currentColor" },
        React.createElement("path", { d: "M3.5 5.75h5.25a3.5 3.5 0 010 7H8h0" }),
        React.createElement("path", { strokeLinejoin: "round", d: "M5.5 3.25L3 5.75l2.5 2.5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
